import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.market.qna');
import { OnInit, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { qna, qnaRecommendedRight } from '../admin-prototype/types';

@Component({
    selector: 'wiz-page-ip-market-qna',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.market.qna/view.scss */
:host {
  display: block;
  height: 100%;
}

.qna-detail-modal {
  background: radial-gradient(circle at 100% 0, rgba(8, 145, 178, 0.06), transparent 18rem), #fff;
}

.qna-detail-summary {
  padding: 1rem 1.25rem 0.9rem;
  border-bottom: 1px solid #e2e8f0;
  background: rgba(255, 255, 255, 0.94);
}

.qna-detail-tabs {
  position: sticky;
  z-index: 4;
  top: 3rem;
  display: grid;
  grid-template-columns: 1.35fr 1fr 0.85fr;
  gap: 0.35rem;
  padding: 0.55rem;
  border-bottom: 1px solid #dbe4ea;
  background: rgba(248, 250, 252, 0.96);
  backdrop-filter: blur(10px);
}

.qna-detail-tabs button {
  display: flex;
  min-width: 0;
  min-height: 3rem;
  align-items: center;
  gap: 0.65rem;
  padding: 0.55rem 0.7rem;
  border: 1px solid transparent;
  border-radius: 0.65rem;
  color: #64748b;
  text-align: left;
  transition: border-color 140ms ease, background-color 140ms ease, color 140ms ease, box-shadow 140ms ease;
}

.qna-detail-tabs button:hover {
  border-color: #cbd5e1;
  color: #334155;
  background: #fff;
}

.qna-detail-tabs button:focus-visible {
  outline: 2px solid #06b6d4;
  outline-offset: 1px;
}

.qna-detail-tabs button.is-active {
  border-color: #a5f3fc;
  color: #0e7490;
  background: #fff;
  box-shadow: 0 6px 18px rgba(8, 145, 178, 0.1);
}

.qna-detail-tab-step {
  display: inline-flex;
  width: 1.75rem;
  height: 1.75rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: #94a3b8;
  background: #e2e8f0;
  font-size: 0.64rem;
  font-weight: 800;
  letter-spacing: 0.04em;
}

.qna-detail-tabs button.is-active .qna-detail-tab-step {
  color: #fff;
  background: #0891b2;
}

.qna-detail-tab-label {
  overflow: hidden;
  font-size: 0.75rem;
  font-weight: 750;
  line-height: 1.15rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.qna-detail-body {
  min-height: 29rem;
  padding: 1rem;
}

.qna-detail-panel[hidden] {
  display: none !important;
}

.qna-detail-panel {
  animation: qna-panel-enter 150ms ease-out both;
}

.qna-unified-card,
.qna-panel-heading,
.qna-reply-history,
.qna-answer-editor {
  border: 1px solid #dbe4ea;
  border-radius: 0.85rem;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.qna-unified-card {
  overflow: hidden;
}

.qna-card-heading,
.qna-panel-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.qna-card-heading {
  padding: 1rem 1.1rem;
  border-bottom: 1px solid #e2e8f0;
  background: linear-gradient(120deg, #f0fdfa, #ecfeff 55%, #f8fafc);
}

.qna-card-heading h3,
.qna-panel-heading h3 {
  margin-top: 0.2rem;
  color: #0f172a;
  font-size: 0.9rem;
  font-weight: 800;
}

.qna-card-eyebrow {
  color: #0891b2;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.qna-card-chip {
  flex: 0 0 auto;
  padding: 0.3rem 0.55rem;
  border: 1px solid #bae6fd;
  border-radius: 999px;
  color: #0369a1;
  background: rgba(255, 255, 255, 0.8);
  font-size: 0.65rem;
  font-weight: 700;
}

.qna-unified-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 0.85rem;
  padding: 1.1rem;
  background: #f8fafc;
}

.qna-unified-section {
  min-width: 0;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  background: #fff;
}

.qna-unified-section + .qna-unified-section {
  border-left: 1px solid #e2e8f0;
}

.qna-section-title {
  display: block;
  color: #334155;
  font-size: 0.75rem;
  font-weight: 800;
}

.qna-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem 1rem;
  margin-top: 0.85rem;
}

.qna-info-grid dt {
  color: #94a3b8;
  font-size: 0.68rem;
}

.qna-info-grid dd {
  margin-top: 0.18rem;
  color: #1e293b;
  font-size: 0.75rem;
  font-weight: 650;
}

.qna-content-section {
  display: flex;
  flex-direction: column;
}

.qna-consultation-copy {
  min-height: 7.5rem;
  margin-top: 0.85rem;
  padding: 0.85rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.6rem;
  color: #334155;
  background: #f8fafc;
  font-size: 0.82rem;
  line-height: 1.65rem;
  white-space: pre-wrap;
  word-break: break-word;
}

.qna-support-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.75rem;
  padding: 0.85rem 1.1rem 1.1rem;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}

.qna-support-card {
  min-width: 0;
  padding: 1rem;
  border: 1px solid #bae6fd;
  border-radius: 0.75rem;
  background: rgba(236, 254, 255, 0.55);
}

.qna-support-card--indigo {
  border-color: #c7d2fe;
  background: rgba(238, 242, 255, 0.62);
}

.qna-support-card--wide {
  grid-column: 1/-1;
  border-color: #e2e8f0;
  background: #fff;
}

.qna-support-card__heading {
  display: flex;
  align-items: center;
  gap: 0.7rem;
}

.qna-support-card__heading p {
  margin-top: 0.12rem;
  color: #64748b;
  font-size: 0.66rem;
  line-height: 1.05rem;
}

.qna-support-card__icon {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.55rem;
  color: #0e7490;
  background: #cffafe;
  font-size: 0.75rem;
}

.qna-support-card--indigo .qna-support-card__icon {
  color: #4338ca;
  background: #e0e7ff;
}

.qna-info-grid--compact {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 0.9rem;
  padding-top: 0.9rem;
  border-top: 1px solid rgba(148, 163, 184, 0.22);
}

.qna-panel-heading {
  margin-bottom: 0.85rem;
  padding: 0.95rem 1rem;
  background: linear-gradient(120deg, #f8fafc, #ecfeff);
}

.qna-panel-heading > p {
  max-width: 25rem;
  color: #64748b;
  font-size: 0.72rem;
  line-height: 1.25rem;
  text-align: right;
}

.qna-reply-history {
  margin-bottom: 0.85rem;
  padding: 1rem;
}

.qna-message-card {
  padding: 0.85rem 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  color: #334155;
  background: #f8fafc;
  font-size: 0.75rem;
  line-height: 1.35rem;
}

.qna-answer-editor {
  display: block;
  padding: 1rem;
}

.qna-reply-footer {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 0.85rem;
  padding: 0.95rem 1rem;
  border: 1px solid #dbe4ea;
  border-radius: 0.85rem;
  background: #f8fafc;
}

@keyframes qna-panel-enter {
  from {
    opacity: 0;
    transform: translateY(0.25rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 720px) {
  .qna-detail-summary {
    padding-inline: 0.9rem;
  }
  .qna-detail-tabs {
    top: 3rem;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.25rem;
    padding: 0.4rem;
  }
  .qna-detail-tabs button {
    min-height: 3.35rem;
    flex-direction: column;
    justify-content: center;
    gap: 0.25rem;
    padding: 0.4rem 0.25rem;
    text-align: center;
  }
  .qna-detail-tab-step {
    width: 1.35rem;
    height: 1.35rem;
    font-size: 0.55rem;
  }
  .qna-detail-tab-label {
    width: 100%;
    font-size: 0.64rem;
    line-height: 0.85rem;
    white-space: normal;
  }
  .qna-detail-body {
    min-height: 24rem;
    padding: 0.7rem;
  }
  .qna-card-heading,
  .qna-panel-heading,
  .qna-reply-footer {
    align-items: flex-start;
    flex-direction: column;
  }
  .qna-panel-heading > p {
    max-width: none;
    text-align: left;
  }
  .qna-unified-grid,
  .qna-support-grid {
    grid-template-columns: minmax(0, 1fr);
  }
  .qna-unified-section + .qna-unified-section {
    border-left: 1px solid #e2e8f0;
  }
  .qna-info-grid--compact {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .qna-support-card--wide {
    grid-column: auto;
  }
  .qna-reply-footer > div:last-child {
    width: 100%;
  }
  .qna-reply-footer button {
    flex: 1 1 0;
  }
}`],
})
export class PageIpMarketQnaComponent implements OnInit {
    @ViewChild('documents') public documents: any;
    public items: any[] = [];
    public selected: any = null;
    public activeDetailTab: 'overview' | 'documents' | 'reply' = 'overview';
    public loading = false;
    public saving = false;
    public error = '';
    public page = 1;
    public totalPages = 1;
    private detailSequence = 0;
    public answerDraft: string = this.selected?.answer || '';
    public search: any = { status: '', channel: '', text: '' };
    public statuses: string[] = ['접수', '배정', '상담중', '답변완료', '보류', '취소'];
    public channels: string[] = ['자유상담', 'AI 추천상담', '기술가치평가'];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public pendingCount() {
        return this.items.filter((item) => item.status === '접수').length;
    }

    public get filteredItems() {
        const text = this.search.text.trim().toLowerCase();
        return this.items.filter((item) => {
            const recommendedRightText = (item.aiRecommendedRights || []).map((right) => [
                right.title,
                right.rightType,
                right.applicationNumber,
                right.registrationNumber,
                right.owner
            ].join(' ')).join(' ');
            const textMatched = !text || [
                item.sourceName,
                item.companyName,
                item.contact,
                item.email,
                item.title,
                item.content,
                this.categoryLabel(item.category),
                item.consultationType,
                item.rightTitle,
                item.applicationNumber,
                item.registrationNumber,
                item.aiSearchSummary,
                recommendedRightText
            ].join(' ').toLowerCase().includes(text);
            const statusMatched = !this.search.status || item.status === this.search.status;
            const channelMatched = !this.search.channel || this.consultationChannel(item) === this.search.channel;
            return textMatched && statusMatched && channelMatched;
        });
    }

    private async api(action: string, args: any = {}) {
        const res = await wiz.call('consultations', { action, ...args });
        if (res.code !== 200) throw new Error(res.data?.error?.message || '상담을 처리하지 못했습니다.');
        return res.data;
    }

    private normalize(item: any) {
        const statuses: any = { RECEIVED: '접수', ASSIGNED: '배정', IN_PROGRESS: '상담중', ON_HOLD: '보류', COMPLETED: '답변완료', CANCELLED: '취소' };
        return { ...item, sourceName: item.requester?.name || '', companyName: item.requester?.office_name || '',
            contact: item.requester?.phone || '', email: item.requester?.email || '',
            title: item.subject || '', content: item.body || item.body_preview || '',
            status: statuses[item.status] || item.status, createdAt: item.created_at,
            privacyConsent: item.privacy_consent, assignee: item.assigned_to,
            consultationChannel: item.category === 'AI_CANDIDATE_CONSULTATION'
                ? 'AI 추천상담'
                : item.category === 'VALUATION_REQUEST'
                    ? '기술가치평가'
                    : '자유상담',
            aiRecommendedRights: item.aiRecommendedRights || item.ai_recommended_rights || [],
            publicMessages: (item.messages || []).filter((message: any) => message.visibility === 'PUBLIC') };
    }

    public async load(page = this.page) {
        if (this.loading || this.saving) return;
        this.loading = true; this.error = '';
        await this.service.render();
        try {
            const data = await this.api('list', { page });
            this.items = (data.items || []).map((item: any) => this.normalize(item));
            this.page = data.pagination?.page || page;
            this.totalPages = data.pagination?.total_pages || 1;
            this.selected = null;
        } catch (e: any) { this.items = []; this.selected = null; this.error = e.message; }
        finally { this.loading = false; await this.service.render(); }
    }

    public async selectItem(item: any) {
        if (this.saving) return;
        const seq = ++this.detailSequence;
        const sameConsultation = this.selected?.id === item.id;
        const nextTab = sameConsultation ? this.activeDetailTab : 'overview';
        const nextAnswerDraft = sameConsultation ? this.answerDraft : '';
        this.selected = null; this.error = '';
        await this.service.render();
        try {
            const data = await this.api('detail', { id: item.id });
            if (seq !== this.detailSequence) return;
            this.selected = this.normalize(data);
            this.activeDetailTab = nextTab;
            this.answerDraft = nextAnswerDraft;
        } catch (e: any) { if (seq === this.detailSequence) this.error = e.message; }
        await this.service.render();
    }

    public async selectDetailTab(tab: 'overview' | 'documents' | 'reply') {
        this.activeDetailTab = tab;
        await this.service.render();
    }

    public async closeDetail() {
        if (this.saving) return;
        this.detailSequence += 1;
        this.selected = null;
        this.activeDetailTab = 'overview';
        this.answerDraft = '';
        await this.service.render();
    }

    public consultationChannel(item: qna): '자유상담' | 'AI 추천상담' | '기술가치평가' {
        return item.consultationChannel || '자유상담';
    }

    public categoryLabel(category: string) {
        switch (category) {
            case 'BUY_INQUIRY': return '구매 문의';
            case 'GENERAL_QNA': return '일반 문의';
            case 'RIGHT_SPECIFIC_QNA': return '권리별 문의';
            case 'REQUIREMENT_QNA': return '요구사항 문의';
            case 'CASE_CONSULTATION': return '건별 상담';
            case 'VALUATION_REQUEST': return '기술가치평가';
            case 'AI_CANDIDATE_CONSULTATION': return 'AI 후보 상담';
            default: return category || '상담';
        }
    }

    public detailSectionTitle(item: any) {
        return item?.category === 'VALUATION_REQUEST'
            ? '기술가치평가 접수 정보'
            : '자유상담 접수 정보';
    }

    public isAiConsultation(item: qna) {
        return this.consultationChannel(item) === 'AI 추천상담';
    }

    public recommendedRights(item: qna): qnaRecommendedRight[] {
        return item.aiRecommendedRights || [];
    }

    public selectedRecommendedRights(item: qna): qnaRecommendedRight[] {
        return this.recommendedRights(item).filter((right) => right.selectedForConsultation);
    }

    public selectedRecommendedCount(item: qna) {
        return this.selectedRecommendedRights(item).length;
    }

    public async save(status: '답변완료' | '보류') {
        if (!this.selected || this.saving) return;
        if (status === '답변완료' && !this.answerDraft.trim()) {
            await this.service.modal.error('답변 내용을 입력해주세요.');
            return;
        }
        const id = this.selected.id;
        this.saving = true; this.error = '';
        await this.service.render();
        try {
            if (status === '답변완료' && this.documents?.hasPendingDelivery?.()) {
                const confirmed = await this.service.modal.show({
                    title: '답변 및 서류 전송',
                    message: '작성한 견적서·첨부서류와 답변을 함께 전송하고 상담을 완료합니다.',
                    action: '전송',
                    cancel: '취소',
                    status: 'warning',
                    actionBtn: 'success'
                });
                if (!confirmed) return;
                const delivered = await this.documents.send(false);
                if (!delivered) {
                    await this.service.modal.error(this.documents.error || '견적서·첨부서류를 전송하지 못했습니다.');
                    return;
                }
            }
            if (status === '답변완료') {
                await this.api('reply', { id, body: this.answerDraft.trim() });
                this.answerDraft = '';
            }
            await this.api('status', { id, status: status === '답변완료' ? 'COMPLETED' : 'ON_HOLD' });
            this.saving = false;
            await this.load();
            await this.service.modal.success(status === '답변완료' ? '답변을 전달하고 상담을 완료했습니다.' : '상담을 보류했습니다.');
        } catch (e: any) { this.error = e.message; }
        finally { this.saving = false; await this.service.render(); }
    }

    public formatDate(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    }

    public statusClass(status: string) {
        switch (status) {
            case '접수': return 'bg-amber-50 text-amber-700 border-amber-200';
            case '답변완료': return 'bg-emerald-50 text-emerald-700 border-emerald-200';
            case '보류': return 'bg-gray-50 text-gray-600 border-gray-200';
            default: return 'bg-gray-50 text-gray-600 border-gray-200';
        }
    }

    public channelClass(channel: string) {
        if (channel === 'AI 추천상담') {
            return 'bg-indigo-50 text-indigo-700 border-indigo-200';
        }
        if (channel === '기술가치평가') {
            return 'bg-amber-50 text-amber-700 border-amber-200';
        }
        return 'bg-cyan-50 text-cyan-700 border-cyan-200';
    }

    public recommendationClass(item: qnaRecommendedRight) {
        return item.selectedForConsultation
            ? 'border-cyan-200 bg-cyan-50/60'
            : 'border-slate-200 bg-white';
    }
}

export default PageIpMarketQnaComponent;